import { render, staticRenderFns } from "./SkeletonGameMenu.vue?vue&type=template&id=5aaa9b58&scoped=true&"
import script from "./SkeletonGameMenu.vue?vue&type=script&lang=js&"
export * from "./SkeletonGameMenu.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonGameMenu.vue?vue&type=style&index=0&id=5aaa9b58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaa9b58",
  null
  
)

export default component.exports